import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=6356ab9f&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&id=6356ab9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356ab9f",
  null
  
)

export default component.exports